import { createContext, useContext, useState } from 'react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const loggedUserContext = createContext(null);
const queryClient = new QueryClient();

export function useLoggedUserContext() {
    const loggedUser = useContext(loggedUserContext);

    if (loggedUser === undefined) {
        throw new Error("No logged user found!");
    }

    return loggedUser;
}

export function AppContext({children}) {
    const [loggedUser, setLoggedUser] = useState(null);

    return <QueryClientProvider client={queryClient}>
        <loggedUserContext.Provider value={[loggedUser, setLoggedUser]}>
            {children}
        </loggedUserContext.Provider>
    </QueryClientProvider>
}